import { useEffect, useState } from "react";

export default function HypothesesRisquesPage({ cabinetId = null }) {

    const STORAGE_KEY = "yoma_hypotheses_risques_page_v1";
    const [hypothesesPrincipales, setHypothesesPrincipales] = useState("");
    const [risquesIdentifies, setRisquesIdentifies] = useState("");
    const [mesuresMitigation, setMesuresMitigation] = useState("");
    const [pointsBloquants, setPointsBloquants] = useState("");
    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        setHypothesesPrincipales(parsed?.hypothesesPrincipales || "");
        setRisquesIdentifies(parsed?.risquesIdentifies || "");
        setMesuresMitigation(parsed?.mesuresMitigation || "");
        setPointsBloquants(parsed?.pointsBloquants || "");
      } catch (_) {}
      setHydrated(true);
    }, []);

    useEffect(() => {
      try {
        if (!hydrated) return;
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            hypothesesPrincipales,
            risquesIdentifies,
            mesuresMitigation,
            pointsBloquants,
          })
        );
      } catch (_) {}
    }, [hypothesesPrincipales, risquesIdentifies, mesuresMitigation, pointsBloquants]);

    const GOLD = "#C9A96E";
    const INK = "#1C1915";
    const INK_SOFT = "#4A4540";
    const BORDER = "#E7E1D8";
    const SOFT_BG = "#F7F5F2";
  
    const cardStyle = {
      background: "#fff",
      border: `1px solid ${BORDER}`,
      borderRadius: 12,
      padding: 22,
    };
  
    const labelStyle = {
      fontSize: 11,
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      color: INK_SOFT,
      fontWeight: 600,
      marginBottom: 6,
      display: "block",
    };
  
    const textareaStyle = {
      width: "100%",
      minHeight: 110,
      padding: "10px 12px",
      border: `1px solid ${BORDER}`,
      borderRadius: 8,
      boxSizing: "border-box",
      fontSize: 13,
      resize: "vertical",
      background: SOFT_BG,
    };
  
    if (cabinetId == null) {
      return <div style={{ padding: 24, textAlign: "center", color: INK_SOFT }}>Chargement...</div>;
    }

    return (
      <div style={{ maxWidth: 1100, fontFamily: "system-ui, sans-serif" }}><div style={{ marginBottom: 24 }}><div style={{
            fontSize: 11,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: GOLD,
            marginBottom: 6,
          }}>
            Décision
          </div><div style={{
            fontSize: 24,
            fontWeight: 700,
            color: INK
          }}>
            Hypothèses & Risques
          </div><div style={{
            fontSize: 13,
            color: INK_SOFT,
            marginTop: 4
          }}>
            Formalisation des hypothèses du projet et identification des risques majeurs.
          </div></div><div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 18
        }}><div style={cardStyle}><label style={labelStyle}>Hypothèses principales</label><textarea
              style={textareaStyle}
              value={hypothesesPrincipales}
              onChange={(e) => setHypothesesPrincipales(e.target.value)}
              placeholder="Ex : délai permis réaliste, coût VRD estimé, accès réseau électrique..."
            /></div><div style={cardStyle}><label style={labelStyle}>Risques identifiés</label><textarea
              style={textareaStyle}
              value={risquesIdentifies}
              onChange={(e) => setRisquesIdentifies(e.target.value)}
              placeholder="Ex : refus VNA, coût poste électrique, terrain non constructible..."
            /></div><div style={cardStyle}><label style={labelStyle}>Mesures de mitigation</label><textarea
              style={textareaStyle}
              value={mesuresMitigation}
              onChange={(e) => setMesuresMitigation(e.target.value)}
              placeholder="Ex : vérifier note de renseignement, étude géotechnique préalable..."
            /></div><div style={cardStyle}><label style={labelStyle}>Points bloquants (GO / NO-GO)</label><textarea
              style={textareaStyle}
              value={pointsBloquants}
              onChange={(e) => setPointsBloquants(e.target.value)}
              placeholder="Ex : pas de lancement sans vérification foncière complète..."
            /></div></div></div>
    );
  }